// extracted by mini-css-extract-plugin
export default {"budgetWidget":"BudgetWidget_budgetWidget__lD5yW","budgetWidgetTitle":"BudgetWidget_budgetWidgetTitle__FTpw7","budgetWidgetBalance":"BudgetWidget_budgetWidgetBalance__0gXsQ"};